<script lang="ts">
  import type { ISLANDS } from '$lib/constants'
  import { t } from '$lib/translations'

  export let href: string
  export let islandLong: (typeof ISLANDS)[number]['long']
  export let islandShort: (typeof ISLANDS)[number]['short']

</script>

<div
  id="card"
  class="w-full h-full rounded-xl xl:rounded-none flex flex-col gap-8"
>
  <h1 class="lg:text-3xl text-base">{islandLong}</h1>
  <p class="text-left text-black">{@html $t(`info.airport_info_${islandShort.toLowerCase()}`)}</p>
  {#if islandShort == 'TF'}
  <div class="text-black">
    <a
    href={'/airports/tenerife_sur.pdf'}
    target="_blank"
    rel="noopener noreferrer"
    class="underline text-left mt-5 font-bold">{$t('common.more_info')} ({$t('info.airport_tfs')}) &gt</a
  >
  <br/>
    <a
      href={'/airports/tenerife_norte.pdf'}
      target="_blank"
      rel="noopener noreferrer"
      class="underline text-left mt-5 font-bold">{$t('common.more_info')} ({$t('info.airport_tfn')}) &gt</a
    >

  </div>
  {:else}
    <a {href} target="_blank" rel="noopener noreferrer" class="underline text-left text-black font-bold"
      >{$t('common.more_info')} &gt;</a
    >
  {/if}

</div>

<style lang="postcss">
  #card {
    background-repeat: no-repeat;
    background-size: cover;
  }
</style>
